
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/Conscious-store",
      function () {
        return require("private-next-pages/explore/Conscious-store.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/Conscious-store"])
      });
    }
  